import React from 'react';
import '../CSS/services.css';
import { Link } from 'react-router-dom';
import custom from '../images/home/custom-software.png';
import cloud from '../images/home/cloud.png';
import erp from '../images/home/erp.png';
import maintenance from '../images/home/maintenance.png';
import webapplication from '../images/home/web-application.png';
import windowsapp from '../images/home/windows-app.png';
import database from '../images/home/database.png';
import digital from '../images/home/digital-marketing.png';
import domain from '../images/home/domain-hosting.png';
import frontend from '../images/home/frontend.png';
import mobile from '../images/home/mobile-app.png';
import websitedeve from '../images/home/website-development.png';

function Services() {
  const services = [
    {
      number: '01',
      title: 'Custom Software Development',
      link: '/services/custom-software',
      image: custom,
      description:
        'Tailored software solutions designed specifically around your business processes, requirements, and operational needs.'
    },
    {
      number: '02',
      title: 'ERP & Business Management',
      link: '/services/erp-business',
      image: erp,
      description:
        'Comprehensive systems for managing inventory, sales, purchases, accounting, customers, and daily business operations.'
    },
    {
      number: '03',
      title: 'Web Application Development',
      link: '/services/web-application',
      image: webapplication,
      description:
        'Modern, secure, responsive, and user-friendly web applications built around your business goals.'
    },
    {
      number: '04',
      title: 'Website Development',
      link: '/services/website-development',
      image: websitedeve,
      description:
        'Professional websites developed using WordPress, PHP, .NET, and modern web technologies to establish a strong online presence.'
    },
    {
      number: '05',
      title: 'Windows Applications',
      link: '/services/windows-application',
      image: windowsapp,
      description:
        'Small and efficient Windows applications developed to simplify business operations and improve productivity.'
    },
    {
      number: '06',
      title: 'Mobile Applications',
      link: '/services/mobile-application',
      image: mobile,
      description:
        'Custom mobile applications developed to provide convenient access to business services, products, and operations.'
    },
    {
      number: '07',
      title: 'Frontend Development',
      link: '/services/frontend-development',
      image: frontend,
      description:
        'Modern and responsive frontend development using React, Angular, Salesforce, and other modern frameworks.'
    },
    {
      number: '08',
      title: 'Database Solutions',
      link: '/services/database-solutions',
      image: database,
      description:
        'Database design, development, and management using SQL, MongoDB, and other database technologies.'
    },
    {
      number: '09',
      title: 'Cloud Solutions',
      link: '/services/cloud-solutions',
      image: cloud,
      description:
        'Scalable cloud-based applications that provide accessibility, flexibility, security, and reliable performance.'
    },
    {
      number: '10',
      title: 'Software Maintenance',
      link: '/services/software-maintenance',
      image: maintenance,
      description:
        'Continuous monitoring, updates, improvements, bug fixing, and technical support to keep your software running smoothly.'
    },
    {
      number: '11',
      title: 'Digital Marketing & SEO',
      link: '/services/digital-marketing',
      image: digital,
      description:
        'Digital marketing solutions using SEO and social media to increase online visibility, reach potential customers, and grow your business.'
    },
    {
      number: '12',
      title: 'Domain & Hosting',
      link: '/services/domain-hosting',
      image: domain,
      description:
        'Domain registration and hosting solutions to help businesses establish and maintain a reliable online presence.'
    }
  ];

  return (
    <>

      {/* ================= HERO ================= */}
      <section className="services-hero">

        <div className="container">
          <div className="services-hero-content">
            <h1>
              Technology Solutions
              <br />
              <span>
                For Business
              </span>
            </h1>
            <p>
              From software development and business applications to
              websites, databases, cloud solutions, and digital marketing,
              we provide technology services designed around your business
              requirements.
            </p>
            <div className="about-hero-buttons">
              <Link to="/contactus" className="about-primary-button" >
                Let's Work Together
              </Link>
              <Link to="/services" className="about-secondary-button" >
                Explore Our Services
              </Link>
            </div>
          </div>
        </div>

      </section>


      {/* ================= INTRO ================= */}
      <section className="services-intro">
        <div className="container">

          <div className="section-heading text-center">


            <h2>
              Complete Technology Solutions Under One Roof
            </h2>

            <p>
              We help businesses transform their ideas, processes, and
              requirements into practical digital solutions. Our services are
              designed to support businesses from their first digital presence
              to complete software systems and long-term technology support.
            </p>
          </div>

        </div>
      </section>


      {/* ================= SERVICES ================= */}
      <section className="services-list-section">
        <div className="container">

          <div className="row g-4">

            {services.map((service) => (
              <div
                className="col-lg-4 col-md-6"
                key={service.number}
              >

                <div className="service-detail-card">

                  <div className="service-detail-image">
                    <img
                      src={service.image}
                      alt={service.title}
                    />


                  </div>

                  <div className="service-detail-content">
                    <Link to={service.link} style={{ textDecoration: 'none' }}>
                      <h3>{service.title}</h3>
                    </Link>
                    <p>{service.description}</p>

                    <div className="service-line"></div>

                  </div>

                </div>
              </div>
            ))}

          </div>

        </div>
      </section>


      {/* ================= TECHNOLOGY ================= */}
      <section className="technology-section">
        <div className="container">

          <div className="row align-items-center g-5">

            <div className="col-lg-6">

              <div className="technology-image">
                <img
                  src="/images/industries/technology.png"
                  alt="Modern technology solutions"
                />
              </div>

            </div>

            <div className="col-lg-6">

              <div className="technology-content">


                <h2>
                  Modern Technologies For Modern Businesses
                </h2>

                <p>
                  We select technologies based on your project requirements,
                  business goals, scalability needs, and long-term maintenance
                  requirements.
                </p>

                <div className="technology-list">

                  <div>
                    <strong>Frontend</strong>
                    <span>React, Angular, Salesforce</span>
                  </div>

                  <div>
                    <strong>Backend</strong>
                    <span>.NET, C#, PHP, APIs</span>
                  </div>

                  <div>
                    <strong>Database</strong>
                    <span>SQL, MongoDB</span>
                  </div>

                  <div>
                    <strong>Web</strong>
                    <span>WordPress, PHP, .NET</span>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>
      </section>


      {/* ================= CTA ================= */}
      <section className="services-cta-section">
        <div className="container">

          <div className="services-cta-box">

            <div className="cta-content">
              <span>LET'S BUILD TOGETHER</span>

              <h2>
                Have A Project In Mind?
              </h2>

              <p>
                Tell us about your requirements and let's discuss how
                technology can help your business.
              </p>
            </div>

            <a
              href="/contactus"
              className="services-cta-button"
            >
              Get In Touch
            </a>

          </div>

        </div>
      </section>
    </>
  );
}

export default Services;